import type {PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useLayoutQueryKey} from '../page-data/loaders/use-layout-query'
import type {AliveChannels} from '../page-data/payloads/header'

type HeaderLiveUpdateChannels = {
  pullRequest: AliveChannels['pullRequest']
  pullRequestState: AliveChannels['pullRequestState']
}

const pullRequestUpdateFilter = (data: PullRequestAliveData) =>
  Boolean(data.event_updates?.git_updated) || Boolean(data.event_updates?.title_updated)

export function useHeaderLiveUpdates({pullRequest, pullRequestState}: HeaderLiveUpdateChannels): void {
  const queryKey = useLayoutQueryKey()

  // Intentional: no watchFor on pullRequestState. A pull request state transition
  // (draft -> ready, open/close/merge) can change many header fields, so refetch on
  // ANY pullRequestState event. Do not scope this down.
  useInvalidateOnAliveUpdate(pullRequest, queryKey, {filter: pullRequestUpdateFilter})
  useInvalidateOnAliveUpdate(pullRequestState, queryKey)
}
